<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-text-field
                        :dense="dense"
                        small
                        label="Search by Name, Email or Cell"
                        outlined
                        :loading="loading"
                        v-model="search"
                        @keyup="searchContacts(search)"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-list dense v-if="searchresults">
                    <v-list-item v-for="(s) in searchresults" @click="selectContact(s)" :key="s.uuid">
                        <v-list-item-content>
                            <v-list-item-title>{{s.name}}</v-list-item-title>
                            <v-list-item-subtitle>{{s.email}} | {{s.cell}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon>
                                <v-icon>{{icons.plus}}</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props: ['clear', 'dense'],
    name: "SearchContact",
    data() {
      return {
        search: '',
        searchresults: undefined,
        loading: false,
        contact: undefined
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    watch: {
      clear(n, o) {
        if (n) this.clearSearch()
      }
    },
    methods: {
      ...mapActions(['post', 'get']),
      async searchContacts(str) {
        if (str.length < 3) {
          this.searchresults = ''
          return;
        }
        this.loading = true;
        this.searchresults = await this.post({path: 'api/contacts/search', body: {str: str}})
        console.log(this.searchresults)
        this.loading = false;
      },
      selectContact(data) {
        this.$emit('contact', data)
        this.clearSearch()
      },
      clearSearch() {
        this.contact = false
        this.search = ''
        this.searchresults = '';
        this.searchcontacts = '';
      },
    }
  }
</script>

<style scoped>

</style>